"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useMemo } from "react";
import { Flex, Box, Text, forwardRef } from "@chakra-ui/react";
import { components } from "react-select";
import { Input, FieldTitle, FieldHelpText, InputVariant, } from "../../atoms/Input";
import { Select } from "../../atoms/Select";
import { FlagIcon } from "../../atoms";
import SvgSpriteConsumer from "../../atoms/SvgSprite/SvgSpriteConsumer";
import { getTextColor, getLabelHoverColor } from "../../helpers";
import { getStyles } from "./PhoneInput.style";
const CustomSingleValue = (_a) => {
    var { data } = _a, props = __rest(_a, ["data"]);
    return (_jsx(components.SingleValue, Object.assign({ data: data }, props, { children: _jsxs(Flex, Object.assign({ alignItems: "center" }, { children: [_jsx(Flex, Object.assign({ mr: "2" }, { children: data.leftElement })), _jsx(Text, Object.assign({ variant: "body.largeDemibold" }, { children: data.value }))] })) })));
};
const PhoneInput = forwardRef(({ countries, defaultInputValue = "", defaultSelectValue = "", onChange, title, mandatory = false, helpText = "", helpTextIcon, disabled = false, variant = InputVariant.FILLED, menuPlacement = "bottom", placeholder, id, }, ref) => {
    var _a;
    const hasOnlyOneCountry = (countries === null || countries === void 0 ? void 0 : countries.length) === 1;
    const phoneInputStyle = getStyles(hasOnlyOneCountry);
    const computedDefaultSelectValue = hasOnlyOneCountry
        ? (_a = countries[0]) === null || _a === void 0 ? void 0 : _a.dial_code
        : defaultSelectValue;
    const [inputValue, setInputValue] = useState(defaultInputValue);
    const [selectValue, setSelectValue] = useState(computedDefaultSelectValue);
    useEffect(() => {
        const selectedCountry = countries.find((country) => country.dial_code === selectValue);
        let newValue = "";
        if (selectedCountry) {
            if (inputValue) {
                newValue = `(${selectedCountry.dial_code})${inputValue}`;
            }
            else {
                newValue = `(${selectedCountry.dial_code})`;
            }
        }
        else {
            newValue = inputValue;
        }
        onChange(newValue);
    }, [onChange, inputValue, selectValue, countries]);
    const options = useMemo(() => {
        if (!(countries === null || countries === void 0 ? void 0 : countries.length)) {
            return [];
        }
        return countries.map((country) => ({
            label: `${country.name} (${country.dial_code})`,
            value: country.dial_code,
            leftElement: (_jsx(Flex, Object.assign({ w: "24px" }, { children: _jsx(FlagIcon, { flagID: `flag${country.code}` }) }))),
        }));
    }, [countries]);
    if (!options.length) {
        return null;
    }
    return (_jsx(Box, Object.assign({ ref: ref, className: "plx-phone-input", sx: Object.assign(Object.assign({}, phoneInputStyle), { ".phone-input-group:hover + label": {
                color: getLabelHoverColor(disabled, variant),
            }, ".chakra-input__left-element": {
                top: 0,
            }, ".chakra-input__right-element": {
                top: 0,
            }, ".pluxee-select__menu": {
                minWidth: "320px",
            } }), color: getTextColor(disabled) }, { children: _jsxs(Box, Object.assign({ display: "flex", flexDirection: "column-reverse" }, { children: [variant !== InputVariant.READONLY && helpText ? (_jsx(Box, Object.assign({ py: "1" }, { children: _jsx(FieldHelpText, { text: helpText, icon: helpTextIcon, variant: variant, disabled: disabled }) }))) : null, _jsxs(Flex, Object.assign({ className: "phone-input-group" }, { children: [_jsx(Box, Object.assign({ width: "120px", sx: {
                                ".pluxee-select__control": {
                                    ".pluxee-select__value-container .pluxee-select__single-value": {
                                        mr: "0",
                                    },
                                    ".pluxee-select__indicators+div": {
                                        margin: "0",
                                    },
                                },
                                ".pluxee-select--is-disabled": {
                                    borderRight: "1px solid",
                                    borderColor: "semantic.border.secondary",
                                },
                            } }, { children: _jsx(Select, { isMulti: false, options: options, onChange: (newValue) => {
                                    setSelectValue(newValue === null || newValue === void 0 ? void 0 : newValue.value);
                                }, customComponents: {
                                    SingleValue: CustomSingleValue,
                                }, defaultValue: options.find((option) => option.value === computedDefaultSelectValue), isDisabled: disabled, variant: 
                                // in case of only one country we need to have the same behaviour as the readonly variant
                                variant === InputVariant.READONLY || hasOnlyOneCountry
                                    ? InputVariant.READONLY
                                    : InputVariant.FILLED, menuPlacement: menuPlacement }) })), _jsx(Input, { w: "200px", type: "number", value: inputValue, onChange: (event) => setInputValue(event.target.value), variant: variant, leftElement: _jsx(SvgSpriteConsumer, { svgId: "phone24", size: 24 }), disabled: disabled, placeholder: placeholder, id: id })] })), title ? (_jsx(FieldTitle, { inputId: id, title: title, mandatory: mandatory, disabled: disabled })) : null] })) })));
});
PhoneInput.displayName = "PhoneInput";
export default PhoneInput;
//# sourceMappingURL=PhoneInput.js.map